<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :nudge-left="100"
    min-width="auto"
    :disabled="readonly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dates"
        readonly
        :data-cy="label"
        :error-messages="errorMessages"
        :placeholder="label"
        outlined
        hide-details="auto"
        :rules="[...rules]"
        class="min-width"
        dense
        solo
        flat
        v-bind="attrs"
        v-on="on"
      >
        <template slot="append">
          <v-icon v-on="on">{{ icons.mdiCalendarMonth }}</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="dates"
      elevation="20"
      v-bind="$attrs"
      :data-cy="`date-picker-${label}`"
      :allowed-dates="allowedDates"
      no-title
      color="primary"
      @input=";(menu = false), $emit('onSelect', dates)"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { mdiCalendarMonth } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import { required } from '@core/utils/validation'
import moment from 'moment'

export default {
  props: {
    label: {
      type: String,
      default: 'Date',
    },
    date: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: () => new Date(),
    },
    isAllowedPastDate: {
      type: Boolean,
      default: false,
    },
    isAllowedFutureDate: {
      type: Boolean,
      default: true,
    },
    isAllowedCurrentDate: {
      type: Boolean,
      default: true,
    },
    errorMessages: { type: [Array, String], default: () => [] },
  },

  setup(props) {
    const menu = ref(false)
    const dates = ref(props.date)
    const formattedDateValue = moment(props.minDate).format('YYYY-MM-DD')

    const allowedDates = val => {
      // Parse the input date
      const inputDate = moment(val, 'YYYY-MM-DD')
      const today = moment() // Current date and time

      // Check if the date matches today's date
      if (inputDate.isSame(today, 'day') && props.isAllowedCurrentDate === true) return true

      // Check if the date is in the future
      if (inputDate.isAfter(today, 'day') && props.isAllowedFutureDate === true) return true

      // Check if the date is in the past
      if (inputDate.isBefore(today, 'day') && props.isAllowedPastDate === true) return true

      return false
    }

    // Watch prop.date and normalize to YYYY-MM-DD
    watch(
      () => props.date,
      (newDate) => {
        if (!newDate) {
          dates.value = null
          return
        }
        const parsedDate = moment(newDate, ['YYYY-MM-DD', 'MM-DD-YYYY'], true)
        dates.value = parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : null
      },
      { immediate: true }
    )


    return {
      dates,
      allowedDates,
      menu,
      required,
      icons: {
        mdiCalendarMonth,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.min-width {
  min-width: 150px;
}
</style>
